import { QRCodeSVG } from "qrcode.react";
import { useEffect, useState } from "react";
import getWhatsappDetails from "./api/getWhatsappDetails";

const WhatsAppIntegration = ({ botId }) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const res = await getWhatsappDetails(botId);
      if (!res.error && res.data) {
        setData(res.data);
      }
    };
    fetchData();
  }, [botId]);

  console.log(data);

  return (
    <div className="flex flex-col flex-1 space-y-6 text-lg">
      {/* Connected Phone Numbers Section */}
      <div className="bg-white w-full shadow-lg rounded-xl p-6">
        <h3 className="text-3xl font-semibold mb-4 text-gray-900">
          Connected Phone Numbers
        </h3>
        <div className="overflow-hidden rounded-xl">
          {/* Header - Hidden on mobile */}
          <div className="hidden sm:grid sm:grid-cols-4 bg-gray-100 text-gray-700 font-medium p-3 text-base">
            <div className="text-left">Phone Number</div>
            <div className="text-left">Status</div>
            <div className="text-left">Business Name</div>
            <div className="text-left">User Name</div>
          </div>

          {/* Body */}
          {data?.whatsapp_number ? (
            <div className="grid grid-cols-1 sm:grid-cols-4 gap-y-2 p-4 border-b hover:bg-gray-50 transition text-gray-800 text-base">
              {/* Phone Number */}
              <div className="sm:col-span-1">
                <span className="font-medium text-gray-500 sm:hidden block mb-1">
                  Phone Number:
                </span>
                +{data.whatsapp_number}
              </div>

              {/* Status */}
              <div className="sm:col-span-1">
                <span className="font-medium text-gray-500 sm:hidden block mb-1">
                  Status:
                </span>
                <span
                  className={`font-medium ${
                    data.status === "ACTIVE" ? "text-green-600" : "text-red-500"
                  }`}>
                  {data.status}
                </span>
              </div>

              {/* Business Name */}
              <div className="sm:col-span-1">
                <span className="font-medium text-gray-500 sm:hidden block mb-1">
                  Business Name:
                </span>
                {data.businessName}
              </div>

              {/* User Name */}
              <div className="sm:col-span-1">
                <span className="font-medium text-gray-500 sm:hidden block mb-1">
                  User Name:
                </span>
                {data.userName}
              </div>
            </div>
          ) : (
            <div className="p-4 text-gray-500">No connected phone numbers</div>
          )}
        </div>
      </div>

      {/* Test Integration Section */}
      <div className="bg-white w-full shadow-lg rounded-xl p-6">
        <h6 className="text-xl font-semibold mb-2">Test Your Integration</h6>
        <p className="text-gray-700 mb-4">
          You can test your WhatsApp integration by sending a message to your
          linked WhatsApp number. Scan the QR code using your smartphone to
          start chatting.
        </p>

        {data?.whatsapp_number ? (
          <div className="flex flex-col md:flex-row w-full items-start justify-between space-y-4 md:space-y-0 md:space-x-6">
            <div className="text-gray-800 font-medium p-3 border border-gray-300 rounded-lg w-full md:max-w-xs bg-gray-50">
              +{data.whatsapp_number}
            </div>
            <div className="p-4 border border-gray-300 rounded-lg shadow-sm">
              <QRCodeSVG
                value={`https://wa.me/${data.whatsapp_number}`}
                size={160}
              />
            </div>
          </div>
        ) : (
          <p className="text-gray-500">No WhatsApp number linked yet.</p>
        )}
      </div>
    </div>
  );
};

export default WhatsAppIntegration;
